/**
 * crmLabels.ts
 *
 * Pure data module: CRM label maps and status lists.
 * This file MUST NOT import any runtime code from @jinzhuan/api-client
 * so that it can be safely imported in Vitest without requiring a built dist.
 *
 * Type literals are declared inline (not derived from ApiComponents) to keep
 * this module free of any external runtime dependency.
 */

// ─── Customer ─────────────────────────────────────────────────────────────────

export type CustomerStatus =
  | 'lead'
  | 'prospect'
  | 'invited'
  | 'visited'
  | 'assessed'
  | 'plan_proposed'
  | 'quoted'
  | 'signed'
  | 'paid'
  | 'manufacturing'
  | 'infused'
  | 'following_up'
  | 'repurchased'
  | 'referred'
  | 'lost';

export const CUSTOMER_STATUS_LABELS: Record<CustomerStatus, string> = {
  lead: '线索',
  prospect: '潜在客户',
  invited: '已邀约',
  visited: '已到访',
  assessed: '已评估',
  plan_proposed: '方案已提',
  quoted: '已报价',
  signed: '已签约',
  paid: '已付款',
  manufacturing: '生产中',
  infused: '已输注',
  following_up: '随访中',
  repurchased: '已复购',
  referred: '已转介绍',
  lost: '已流失',
};

export const CUSTOMER_STATUS_LIST: readonly CustomerStatus[] = [
  'lead', 'prospect', 'invited', 'visited', 'assessed',
  'plan_proposed', 'quoted', 'signed', 'paid', 'manufacturing',
  'infused', 'following_up', 'repurchased', 'referred', 'lost',
];

// ─── Intent level ─────────────────────────────────────────────────────────────

export type IntentLevel = 'high' | 'medium' | 'low' | 'none';

export const INTENT_LEVEL_LABELS: Record<IntentLevel, string> = {
  high: '高',
  medium: '中',
  low: '低',
  none: '无',
};

// ─── Followup type ────────────────────────────────────────────────────────────

export type FollowupType = 'phone_call' | 'wechat' | 'email' | 'visit' | 'meeting' | 'other';

export const FOLLOWUP_TYPE_LABELS: Record<FollowupType, string> = {
  phone_call: '电话',
  wechat: '微信',
  email: '邮件',
  visit: '上门',
  meeting: '会面',
  other: '其他',
};

// ─── Source type ──────────────────────────────────────────────────────────────

export type SourceType =
  | 'natural_visit'
  | 'referral'
  | 'channel_partner'
  | 'repurchase'
  | 'marketing_event'
  | 'online_lead';

export const SOURCE_TYPE_LABELS: Record<SourceType, string> = {
  natural_visit: '自然到访',
  referral: '转介绍',
  channel_partner: '渠道合作',
  repurchase: '复购',
  marketing_event: '营销活动',
  online_lead: '线上线索',
};

// ─── ChannelPartner status ────────────────────────────────────────────────────

export type ChannelPartnerStatus = 'active' | 'inactive' | 'suspended';

export const CHANNEL_PARTNER_STATUS_LABELS: Record<ChannelPartnerStatus, string> = {
  active: '活跃',
  inactive: '停用',
  suspended: '暂停',
};

// ─── Handoff status ───────────────────────────────────────────────────────────

export type HandoffStatus = 'pending' | 'confirmed' | 'rejected';

export const HANDOFF_STATUS_LABELS: Record<HandoffStatus, string> = {
  pending: '待确认',
  confirmed: '已确认',
  rejected: '已拒绝',
};
// ─── CustomerAccount status ───────────────────────────────────────────────────
export type CustomerAccountStatus = 'active' | 'suspended';
export const CUSTOMER_ACCOUNT_STATUS_LABELS: Record<CustomerAccountStatus, string> = {
  active: '正常',
  suspended: '已暂停',
};
